var e = {
	hotelTitle: "Hotel photos",
	roomTypeTitle: "Room type photos",
	add: "Add photos",
	cover: "Cover",
	actions: "Photo actions",
	makeCover: "Make cover",
	moveBackward: "Move backward",
	moveForward: "Move forward",
	delete: "Delete photo",
	deleteTitle: "Delete this photo?",
	deleteBody: "It is removed from this gallery and from every page that shows it.",
	deleted: "Photo deleted",
	coverSet: "Cover updated",
	moved: "Photo moved",
	uploading_one: "Uploading {{count}} photo…",
	uploading_other: "Uploading {{count}} photos…",
	uploaded_one: "{{count}} photo added",
	uploaded_other: "{{count}} photos added",
	skipped_one: "{{count}} photo couldn't be added",
	skipped_other: "{{count}} photos couldn't be added",
	processing: "Processing",
	rejected: "Couldn't process this photo",
	declined: "Not published",
	pendingLocked: "This photo is still uploading. Try again once it has finished.",
	minHotel_one: "A hotel keeps at least {{count}} photo",
	minHotel_other: "A hotel keeps at least {{count}} photos",
	minRoomType_one: "A room type keeps at least {{count}} photo",
	minRoomType_other: "A room type keeps at least {{count}} photos",
	emptyTitle: "No photos yet",
	emptyHotelBody: "Add photos of the building, the lobby and the facilities every guest shares.",
	emptyRoomTypeBody: "Add photos of this room type. Its cover is what guests see on every card.",
	saveFailed: "Couldn't save the change. Please try again.",
	uploadsDisabled: "Photo uploads are unavailable right now."
};
//#endregion
export { e as default };
